import React from "react";
import PropTypes from "prop-types";
import { DynamicText } from "@/ui";
import clsx from "classnames";
import classes from "./styles.module.scss";

/**
 *
 * @param className
 * @param title
 * @param tag
 * @returns {React.DetailedReactHTMLElement<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>|JSX.Element|null}
 * @constructor
 */
export default function Title({ className, title, tag }) {
  if (!title) {
    return null;
  }

  if (typeof title === "string") {
    return React.createElement(tag, {
      className: clsx(classes.title, className),
      dangerouslySetInnerHTML: { __html: title },
    });
  }

  return (
    <DynamicText className={clsx(classes.title, className)} path={title.path} tag={tag}>
      {title.placeholder}
    </DynamicText>
  );
}

Title.defaultProps = {
  className: "",
  tag: "h2",
  title: null,
};

Title.propTypes = {
  className: PropTypes.string,
  tag: PropTypes.oneOf(["h1", "h2", "h3", "h4", "h5", "h6"]),
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};
